import React from 'react';
import { Legend, Line, ReferenceLine, XAxis, YAxis } from 'recharts';
import { theme } from '../../../../theme';
import { LineChart } from '../../../../components/Chart/LineChart';
import { LineBlueFilter } from '../../../../components/Chart/LineBlueFilter';
import { useTranslation } from 'react-i18next';

export const KolibriLineChart = ({
    data: {
        title,
        series: [seriesPresent, seriesAbsent, seriesFuture],
        referenceLines,
    },
}) => {
    const { t } = useTranslation();

    return (
        <LineChart>
            <defs>
                <LineBlueFilter />
            </defs>

            <XAxis
                dataKey="x"
                type="number"
                domain={[0, 'dataMax']}
                hide={true}
            />
            <YAxis
                dataKey="y"
                type="number"
                domain={[
                    (dataMin) => Math.floor(dataMin) - 5,
                    (dataMax) => Math.ceil(dataMax) + 5,
                ]}
                axisLine={false}
                tickLine={false}
                unit="%"
                width={30.2}
                ticks={referenceLines}
                interval={0}
            />

            {seriesPresent.map((series, i) => (
                <Line
                    key={`present${i}`}
                    data={series}
                    dataKey="y"
                    type="monotone"
                    dot={false}
                    strokeWidth={2}
                    stroke={theme.palette.primary.main}
                    // TODO find out why it removes flat lines
                    // filter={lineBlueFilter}
                />
            ))}

            {seriesAbsent.map((series, i) => (
                <Line
                    key={`absent${i}`}
                    data={series}
                    dataKey="y"
                    type="monotone"
                    dot={false}
                    strokeWidth={2}
                    strokeDasharray="8 8"
                    stroke={theme.palette.primary.chart.spiro.absent}
                />
            ))}

            {seriesFuture.map((series, i) => (
                <Line
                    key={`future${i}`}
                    data={series}
                    dataKey="y"
                    type="monotone"
                    dot={false}
                    strokeWidth={2}
                    stroke={theme.palette.primary.chart.spiro.future}
                />
            ))}

            {referenceLines.map((line, i) => (
                <ReferenceLine
                    key={`referenceLine${i}`}
                    y={line}
                    stroke={theme.palette.primary.chart.spiro.referenceLine}
                    strokeWidth={1}
                    strokeDasharray={line !== 100 ? '9 5' : 'none'}
                />
            ))}

            <Legend
                verticalAlign="bottom"
                align="right"
                height={20}
                payload={[
                    { value: t(`homePage.kolibri.${title}`), type: 'line' },
                ]}
            />
        </LineChart>
    );
};
